import React from 'react';
import GameIcon from './GameIcon';

export default function TopBar({ coins, timerDisplay, timerIsLow, missionName, onBack, gameStep, gameSettings = {} }) {
  return (
    <div className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-5xl mx-auto px-3 py-2.5 flex items-center justify-between gap-3">
        {/* Left: Back */}
        <button
          onClick={onBack}
          className="flex items-center gap-1.5 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="hidden sm:inline">{gameSettings.topbar_back_button || 'Back'}</span>
        </button>

        {/* Center: Mission name + Timer */}
        <div className="flex items-center gap-3 flex-1 justify-center min-w-0">
          {missionName && gameStep !== 'mission-select' && (
            <span className="text-sm font-semibold text-gray-800 truncate max-w-[180px] sm:max-w-none">
              {missionName}
            </span>
          )}
          {timerDisplay && gameStep !== 'mission-select' && gameStep !== 'mission-complete' && (
            <span className={`text-sm font-mono font-bold px-2.5 py-1 rounded-full ${
              timerIsLow
                ? 'bg-red-100 text-red-700 animate-pulse'
                : 'bg-gray-100 text-gray-700'
            }`}>
              {timerDisplay}
            </span>
          )}
        </div>

        {/* Right: Tokens */}
        <div className="flex items-center gap-1.5 bg-amber-50 border border-amber-200 rounded-full px-3 py-1.5 flex-shrink-0">
          <span className="text-base"><GameIcon icon={gameSettings.icon_token || '🪙'} /></span>
          <span className="text-sm font-bold text-amber-800">{coins}</span>
        </div>
      </div>
    </div>
  );
}
